import { variant } from 'styled-system';

export const ButtonSizeArray = [
    'auto',
    'xsmall-narrow',
    'xsmall',
    'small-narrow',
    'small',
    'medium-narrow',
    'medium',
    'large',
] as const;
type ButtonSizeTuple = typeof ButtonSizeArray;
export type ButtonSize = ButtonSizeTuple[number];

type ButtonSizeProps = {
    fontSize: string;
    padding: string;
};

export const sizeVariant = variant<ButtonSizeProps, ButtonSize>({
    prop: 'size',
    variants: {
        auto: {
            fontSize: 'inherit',
            padding: '0',
        },
        'xsmall-narrow': {
            fontSize: '12px',
            padding: '4px 20px',
        },
        xsmall: {
            fontSize: '12px',
            padding: '.75em 2em',
        },
        'small-narrow': {
            fontSize: '14px',
            padding: '4px 20px',
        },
        small: {
            fontSize: '14px',
            padding: '.75em 2em',
        },
        'medium-narrow': {
            fontSize: '16px',
            padding: '4px 20px',
        },
        medium: {
            fontSize: '16px',
            padding: '.75em 2em',
        },
        large: {
            fontSize: '22px',
            padding: '1em 3em',
        },
    },
});
